/** Normalize an asset's admin info text for display. Returns the trimmed
 *  text, or null when there is nothing to show (undefined / null / empty /
 *  whitespace-only). AssetInfoBox renders nothing for null. Internal line
 *  breaks are preserved (only the ends are trimmed). */
export function assetInfoText(info?: string | null): string | null {
  if (!info) return null;
  const trimmed = info.trim();
  return trimmed ? trimmed : null;
}
